/**
 * Указываем, какое количество дней будет отображаться в статистикe цен
 */
export const COUNT = 40;
